import { crossBackLace, mixBackLace, straightBackLace } from 'src/features/brands/treasure/canvas/glove/back/lace/backLace'
import { treasureLabel } from 'src/features/brands/treasure/canvas/labels/treasure'
import { Brand, Position, State } from 'src/types'
import { treasureEngravedOfCatchFace } from 'src/features/brands/treasure/canvas/labels/treasure'
import {
  crossBackLace as crossBackLaceOfFront,
  straightBackLace as straightBackLaceOfFront
} from 'src/features/brands/treasure/canvas/glove/front/lace/backLace'
import { outfielderDefaultBackLace } from 'src/features/brands/treasure/canvas/glove/back/lace/outfielderDefaultBackLace'
import { outfielderDefaultBackLaceForFront } from 'src/features/brands/treasure/canvas/glove/front/lace/outfielderDefaultBackLace'
import { backStyleChecker } from 'src/util/useModelDesign'

export const backLaceDrawerOfFront = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLaceOfFront(ctx, laceColor, 0, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'crossAndStraight':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'cross':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      crossBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      crossBackLaceOfFront(ctx, laceColor, 225, -265, 30)
      return
    default:
      switch (position) {
        case 'outfielder':
          crossBackLaceOfFront(ctx, laceColor, 5, -15, 1)
          outfielderDefaultBackLaceForFront(ctx, laceColor, 0, 20, 0)
          return
        default:
          return
      }
  }
}

export const backLaceDrawer = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLace(ctx, laceColor)
      return
    case 'crossAndStraight':
      mixBackLace(ctx, laceColor)
      return
    case 'cross':
      crossBackLace(ctx, laceColor)
      return
    default:
      switch (position) {
        case 'outfielder':
          outfielderDefaultBackLace(ctx, laceColor)
          return
        default:
          return
      }
  }
}

export const brandLabelDrawerForGlove = (ctx: CanvasRenderingContext2D, state: State, brand: Brand): void => {
  const { isFirstBackStyle } = backStyleChecker(state.backStyle?.value)
  switch (brand) {
    case 'treasure':
      if (isFirstBackStyle) {
        if (state.labelPosition?.value === 'thumbSide') {
          treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, 20, -70, 0, 1)
        }
        if (state.labelPosition?.value === 'littleSide') {
          treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, -95, -30, 5, 0.87)
        }
      } else {
        if ('normal' === state.beltType?.value) {
          treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, -65, -5, 0, 1)
        }
        if ('thumbOver' === state.beltType?.value) {
          treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, -145, 190, -25, 0.9)
        }
        if (['thumbIntegrated', 'treasureOriginal'].includes(state.beltType?.value)) {
          //thumbOverでも linerBackでもない場合
          treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, -25, -5, 0, 1)
        }
      }
      break
  }
}

export const brandLabelDrawerForCatcherMitt = (ctx: CanvasRenderingContext2D, state: State, brand: Brand): void => {
  switch (brand) {
    case 'treasure':
      if (state.backStyle?.value === 'regularBackStyle') {
        if (state.labelPosition?.value === 'littleSide') {
          return treasureLabel(
            ctx,
            state.treasureLabelMain.color,
            state.treasureLabelShadow.color,
            state.treasureLabelStand.color,
            -190,
            -810,
            100,
            0.9
          )
        }
        if (state.labelPosition.value === 'thumbSide') {
          return treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, -40, 40, 0, 0.9)
        }
      }
      if (state.backStyle?.value === 'beltBackStyle') {
        if (state.beltType?.value === 'thumbOver') {
          return treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, 50, 40, -5, 0.9)
        }
        return treasureLabel(ctx, state.treasureLabelMain.color, state.treasureLabelShadow.color, state.treasureLabelStand.color, -40, 115, 0, 0.9)
      }
      break
  }
}

// メーカー捕球面の刻印
export const engravedDrawer = (ctx: CanvasRenderingContext2D, brand: Brand, catchFaceColor: string): void => {
  switch (brand) {
    case 'treasure':
      treasureEngravedOfCatchFace(ctx, -90, -70, catchFaceColor)
      break
  }
}
